const parseQueryParams = (search, pageLimit = 15) => {
    const params = new URLSearchParams(search);
    const page = params.get('page') ? Number(params.get('page')) : 1;
    const perPage = params.get('perPage') ? Number(params.get('perPage')) : pageLimit;
    const searchTerm = params.get('searchTerm') ? params.get('searchTerm') : '';
    const name = params.get('name') ? params.get('name') : '';
    const date = params.get('date') ? params.get('date') : '';
    const criteria = params.get('criteria') ? params.get('criteria') : [];
    const growers = params.get('growers') ? params.get('growers').split(',') : [];
    const buyers = params.get('buyers') ? params.get('buyers').split(',') : [];

    return {page, perPage, searchTerm, date, name, criteria, growers, buyers};
};

export {parseQueryParams};
